export interface IWorkflowStepDetails {
    id:number,
    name:string,
    stepNumber:number
}

// Based off of the same in the Enum file in the Entities project in the back-end.
export enum eWorkflowQueues
{
    Keywords = -1,
    DataEntry = -2,
    DataTranscribe = -3,
    DataTranscribeValidation = -4,
    FARS = -5,
    SpotMapping = -6,
    LocationReview = -7,
    Checkers = -8,
    Matching = -9,
    Management = -10
}

export interface ITranscriberDrafts {
    id:number,
    transcriberValidationData:string,
    transcriberData:string,
    workflowItemId:number
}
